var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 392 369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6ef78;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ec7d64;\n      }\n\n      .cls-3 {\n        fill: #fcb65d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero-circle"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-3",
    cx: 157.5,
    cy: 19.5,
    rx: 20.5,
    ry: 19.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-1",
    cx: 244,
    cy: 222,
    rx: 148,
    ry: 147
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-2",
    cx: 34,
    cy: 57.5,
    rx: 34,
    ry: 33.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCircle);
export default __webpack_public_path__ + "static/media/hero-circle.08adccf2336d9e54484563a129a251b8.svg";
export { ForwardRef as ReactComponent };